






import { Component, Mixins } from "vue-property-decorator";
import { MainMenu } from "./menu";

@Component({
  components: {
    MainMenu,
  }
})
export default class Home extends Mixins() {
}
